// extracted by mini-css-extract-plugin
export var content = "_q7-1";
export var fullScreen = "_q7-0";